module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "about-the-author"
    }
  }, [_c('h1', [_vm._v("About the Author")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("As a boy, Cesare J. Stellato always seemed to emit a presence of curiosity. His mother would force him out of his thoughts and into the world, but he always admired the playground inside his mind more than the one near his childhood home. In many ways he’s still that curious boy, only now the playground is boundless. Until recently, he didn’t think he’d ever release a collection of writing, but certain events compelled him to share his story.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("Individuals born with a hearing disability tend to develop an overtly observant nature. Being one of those individuals, the world reveals itself to Cesare J. Stellato through a more magnified lens. This inherent quality has become the catalyst of his engagement with the world, acting as the foundation of his character. If deliberate attention to detail wanders, relevant information may be misconstrued, thus diminishing the value of a potential lesson. Still and all, observation has become such a significant aspect of his identity that it has transcended from the physical to the self.")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "0em !important"
    }
  }, [_vm._v("When self-observation serves as the foundation of one’s identity, discovery is an inward experience where the contention between what is and what could be finds peace in the process. "), _c('em', [_vm._v("Adonia")]), _vm._v(", above all else, is the peace and the process.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ad60488","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch001.vue
// module id = 63
// module chunks = 0